<template>
  <section class="my-30">
      <Container>
        <SectionHeader>Documents</SectionHeader>
        <div class="flex flex-wrap gap-10">
          <a
            v-for="doc in getDocuments"
            :key="doc.url"
            :href="doc.url"
            target="_blank"
            class="flex gap-4 items-center hover:underline!"
          >
            <FontAwesomeIcon 
              icon="file-pdf" 
              size="lg"
              :class="{
                'text-primary-color': !getPrimaryColor,
                [`text-[${getPrimaryColor}]`]: getPrimaryColor
              }"
            />
            <span class="text-secondary-color text-base">{{ doc.name }}</span>
          </a>
        </div>
      </Container>
  </section>
</template>

<script>
  import { mapGetters } from 'vuex';

  import SectionHeader from '../../components/SectionHeader';
  import Container from '../../components/Container';

  export default {
    name: 'Documents',
    components: {
      SectionHeader,
      Container
    },
    computed: {
      ...mapGetters('tour', ['getDocuments', 'getPrimaryColor'])
    }
  };
</script>
